import React, { useContext, useEffect } from 'react';
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useLoader } from "../../../../hooks/useLoader";
import { EntityWithIdFields, QueryStatus } from "../../../../types";
import { Alert, Grid } from "@mui/material";
import { OperacionADCM } from "./types/types";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { SistemaTipo } from "../../../../types/enum/enum";
import SeccionADCMDatosOperacion from './components/SeccionADCMDatosOperacion';
import { useOperacionADCM } from './hooks/useOperacionADCM';
import SeccionADCMDetalleTransaccion from './components/SeccionADCMDetalleTransaccion';
import SeccionADCMUnderwriting from './components/SeccionADCMUnderwriting ';
import SeccionADCMBridgeLoan from './components/SeccionADCMBridgeLoan';

interface SistemaADCMContentProps {
  operacion: OperacionADCM,
  codSistema: number,
}

const SistemaADCMContent = ({ operacion, codSistema }: SistemaADCMContentProps) => {

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionADCMDatosOperacion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionADCMDetalleTransaccion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionADCMUnderwriting operacion={operacion} />
        </Grid>

        <Grid item xs={12}>
          <SeccionADCMBridgeLoan operacion={operacion} />
        </Grid>

        <Grid item xs={12}>
          <Grid item xs={12}>
            <SeccionFirmas
              codSistema={SistemaTipo.ADCM}
              idOperacion={operacion.id}
            />
          </Grid>
        </Grid>

      </Grid>
    </>
  )
}

function SistemaADCM() {
  const { idOperacion, codSistema } = useContext<ContextOperacionType>(ContextOperacion)

  const { status, operacion, } = useOperacionADCM(idOperacion)

  const { showLoader, hideLoader } = useLoader()

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status])


  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  else {

    if (!operacion) {
      return (
        <></>
      )
    }
  }

  return (
    <SistemaADCMContent
      operacion={operacion}
      codSistema={codSistema}
    />
  )
}

export default SistemaADCM;
